import { Subject } from 'rxjs';
import { CoordinatorService } from './coordinator.service';

export class FilesystemCommunicator {
    tag = 'files';
    firstTag = 'Upload';

    update$: Subject<void> = new Subject();
    private _size = 0;
    maxPreviewLen = 20;

    fsDir: FileSystemDirectoryHandle | undefined;

    constructor(public coords: CoordinatorService) {
        this.coords.worker$.parser.response$.subscribe((resp: any) => {
            switch (resp.action) {
                case 'connection':
                    return;
                case 'command':
                    this._command(resp.payload);
                    break;
            }
        });

        this.coords.worker$.report.response$.subscribe((resp: any) => {
            const data = resp?.payload;

            if (!data) {
                console.log('No data received from Report worker');
                return;
            }

            data.payload && this.coords.filesystem$.saveFile2(data.filename, data.payload);
        });
    }

    setHelpId() {
        this.coords.display$.lastDialogAction = 'parse-files';
    }

    get source() {
        return this.coords.text('Filesystem');
    }

    get dialogTitle() {
        return this.coords.text('SelectFiles');
    }

    private async _command(params: any) {
        switch (params.name) {
            case 'save-file':
                this.coords.filesystem$.saveFile2(params.filename, params.payload);
                break;
        }
    }

    get info() {
        return {
            hits: this.connection.get('_hits'),
        };
    }

    get size() {
        if (this.coords.databin$.communicatorStage$.getValue() === 4) {
            return this.connection && this.connection.size;
        }

        return this._size;
    }

    get connection() {
        return this.coords.databin$.editedConnection$.getValue()!;
    }

    async importFiles(fileLs: FileList) {
        if (!fileLs?.length) {
            console.log('No file(s) uploaded');
            return;
        }

        this.connection.clear();

        const parsers = Array.from(fileLs).map((f) => {
            return this.coords.databin$.createParserFile({
                connection: this.connection,
                f,
            });
        });

        parsers.forEach(async (parser) => await parser.parse());
    }

    clear() {
        this.coords.worker$.parser.directPost({
            action: 'clear',
            payload: {
                originId: this.connection.id,
            },
        });
        this.update$.next();
    }

    async confirm(payload?: any) {
        if (this.connection.inProject) {
            this.connection.set('title', payload.title);
            this.connection.set('description', payload.description);
        } else this.connection.finalize();

        this.coords.databin$.communicatorStage$.next(0);
    }

    chooseFiles() {
        this.coords.filesystem$.pickFiles(true).then((files) => {
            this.importFiles(files);
        });
    }

    step2Next() {
        this.coords.databin$.communicatorStage$.next(3);
    }
}
